export enum AdministrationRoutingScopes {
	COMPANIES = "companies",
	CATALOG = "catalog",
	SOFTWARE_VENDOR = "software-vendor",
	ORCA_ADMIN = "orca-admin",
	USER = "user",
	PREVIEW = "preview"
}